import type { Dict } from '../utils'

import { createContext } from '../utils'

const [TreeProvider, useTreeContext] = createContext<Dict>({ isOptional: true })

export { TreeProvider, useTreeContext }
